import { normalizeKeywords } from '~/modules/retailMedia/helpers/keywords'

const fakeBudget: CommonSettings = {
  daily_budget: '0',
  cpc: '0',
  cpm: '0'
}

export const DTOPayloadMinCostsOffsite: IDTOMinCostsOffsite = {
  banner: data => ({
    start_at: data.start_date,
    type: 'off_site',
    banner: {
      keywords: normalizeKeywords(data.targeting?.keywords),
      categories: data.targeting?.categories?.split(',') || null,
      assets: data.banners.map(item => ({
        ad_size: item.ad_size,
        alt_text: item.alt_text,
        media_url: item.media_url
      }))
    },
    settings: {
      ...fakeBudget
    }
  })
}
